import ApiServices from "@/services/uteis/ApiServices.js";
import routesLogin from "@/libs/endPoint/acesso/CredenciamentoRoutes.js";
import store from "@/store/index.js";
class CredenciamentoServices {
  // Não precisa de construtor

  async login(payload) {
    try {
      const url = routesLogin.login;
      const { data } = await ApiServices.post(url, payload);
      if (data.success) {
        store.commit("login/setUsuarioLogado", data.data);
      }
      return data;
    } catch (error) {
      console.error("Erro ao fazer login:", error);
      throw error;
    }
  }
  async solicitarKeyResetSenha(payload) {
    try {
      const url = routesLogin.resetsenha;
      const { data } = await ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao solicitar reset de senha:", error);
      throw error;
    }
  }
  async trocarSenha(payload) {
    try {
      const url = routesLogin.mudarSenha;
      const { data } = await ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao trocar senha:", error);
      throw error;
    }
  }

  async logOff() {
    try {
      const url = routesLogin.logOff;
      const { data } = await ApiServices.post(url, {});
      return data;
    } catch (error) {
      // verificar se é erro 401
      if (error.response && error.response.status === 401) {
        this.validarLog();
        return { success: true, message: "Usuário já deslogado." };
      }
    }
  }
  validarLog() {
    if (localStorage.getItem("token")) {
      console.log('tem token')
      const payload = JSON.parse(atob(localStorage.getItem("token").split(".")[1]));
      const adminWeb = payload.acessos.find((a) => a.id === 2);
      if (adminWeb) {
        payload.adminWeb = true;
      } else {
        payload.adminWeb = false;
      }
      store.commit("config/setUsuarioLogado", payload);
      store.commit("login/setLogado", true);
    } else {
        console.log('não tem token')
      store.commit("config/setUsuarioLogado", null);
      store.commit("login/setLogado", false);
    }
  }

  async alterarEmail(payload) {
    try {
      const url = routesLogin.alteraremail;
      const { data } = await ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao alterar email:", error);
      throw error;
    }
  }

  async buscarUsuario(cpf) {
    try {
      const url = routesLogin.usuarioBuscar(cpf);
      const { data } = await ApiServices.get(url);
      store.commit("login/setDadosUsuario", data.data);
      return data;
    } catch (error) {
      console.error("Erro ao buscar usuário:", error);
      throw error;
    }
  }

  async updateUsuario(payload) {
    try {
      const url = routesLogin.usuarioAlterar;
      const { data } = await ApiServices.put(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao atualizar usuário:", error);
      throw error;
    }
  }

  async updateSenhaUsuario(payload) {
    try {
      const url = routesLogin.usuarioAlterarSenha;
      const { data } = await ApiServices.post(url, payload);
      return data;
    } catch (error) {
      console.error("Erro ao atualizar senha do usuário:", error);
      throw error;
    }
  }

  async autenticarTokenMobile(key, cpf) {
    try {
      const url = routesLogin.autenticarTokenMobile;

      const { data } = await ApiServices.post(url, { key, cpf });

      if (data.success && data.data && data.data.token) {
        localStorage.setItem("token", data.data.token);
        this.validarLog();
      }
      return data;
    } catch (error) {
      console.error("Erro ao autenticar token mobile:", error);
      throw error;
    }
  }

  async solicitacaoTokenMobile(cpf) {
    try {
      const url = routesLogin.solicitacaoTokenMobile(cpf);

      const { data } = await ApiServices.post(url);

      return data;
    } catch (error) {
      console.error("Erro ao solicitar token para mobile:", error);
      throw error;
    }
  }

  // FIM DA CLASSE---------------------
}

export default new CredenciamentoServices();
